export const exportTextToBucketDocumentationMarkdown = `
# Export patient data to the Secure Notable Cloud

Securely store data created or retrieved within this flow in this patient's secure cloud storage bucket

### Input
 - **Patient**: Select the *GetPatient* block that retrieved the patient for this flow
 - **Source**: Select the block that outputs the text you'd like to securely store
`;
